angular.module('gym.grading').factory('GradingStyles', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('grading').all('styles');
}]);
